function FontAwesomeIcon({icon, className, spin, onChange}) {
	if(spin) className += ' fa-spin';
	return (<i className={icon + ' ' + className} onChange={onChange}></i>)
}
export default FontAwesomeIcon